type Props = {
  id: string
  name: string
  labelComponent?: JSX.Element | JSX.Element[]
  label?: string
  helpText?: string
  errorText?: string
  checked?: boolean
  isRound?: boolean
  isSmall?: boolean
  containerClasses?: string
  handleCheckboxChange: (e: React.FormEvent<HTMLInputElement>) => void
  labelClass?: string
} & typeof defaultProps

const defaultProps = {
  label: '',
  helpText: '',
  errorText: '',
  checked: false,
}
const Checkbox = ({
  labelClass,
  name,
  labelComponent,
  label,
  helpText,
  errorText,
  checked,
  isRound,
  isSmall,
  containerClasses,
  handleCheckboxChange,
}: Props): JSX.Element => (
  <div className={`pt-2 ${containerClasses || ''}`}>
    <label
      className={`text-grey ${isSmall ? 'text-sm' : ''} ${
        labelClass || 'flex items-center'
      }`}
    >
      <input
        className={`form-checkbox cursor-pointer flex
        ${isRound ? 'rounded-full' : 'rounded'}
        ${isSmall ? 'h-4 w-4' : ''}`}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleCheckboxChange}
      />
      {label && <span className="pl-3">{label}</span>}
      {labelComponent && <div className="pl-3">{labelComponent}</div>}
    </label>
    {helpText && (
      <div className="text-grey text-sm font-400 py-2">{helpText}</div>
    )}
    {errorText && (
      <div className="text-red-200 text-sm font-400 py-2">{errorText}</div>
    )}
  </div>
)

Checkbox.defaultProps = defaultProps
export default Checkbox
